import { Cmarkdown } from '@/components/ui/Cmarkdown';
import { FontWeight } from '@/theme/typography';

export interface LegalDocumentContentProps {
  content: string;
}

export function LegalDocumentContent({ content }: LegalDocumentContentProps) {
  return (
    <Cmarkdown
      content={content}
      textSize={17}
      textWeight={FontWeight.Regular}

    />
  );
}
